
import app from './../index';

export default class VossIso {

  constructor() {
    this.templateUrl = "components/vossIso.html";
    this.restrict = "E";
    this.scope = {
      artikelGruppe: "="
    };
  }

  //link(scope, element, attributes)
  link(scope) {
    if (!scope.artikelGruppe) {
      return;
    }

    scope.updateMenge = (artikel) => {
      const aa = app.artikel.find(a => a.id === artikel.id);
      if (aa) {
        artikel.menge = aa.menge;
      }
      if (artikel.unterArtikel) {
        artikel.unterArtikel.forEach(a => scope.updateMenge(a));
      }
    };

    scope.calculateTotal = (gruppe) => {
      gruppe.menge = gruppe.artikel.unterArtikel.sum(a => a.menge || 0) + (gruppe.artikel.menge || 0);
    };

    scope.onOpen = () => {
      scope.artikelGruppe
        .filter(g => g.open && !g.artikel)
        .forEach(a => {
          a.artikel = app.api.artikel.get({
            id: a.artikelId
          });
        });
    };

    scope.artikelGruppe
      .filter(g => app.artikel.some(a => (a.Id === g.artikelId) || (a.hauptArtikel && a.hauptArtikel.id === g.artikelId)))
      .forEach(g => {
        app.api.artikel.get({
          id: g.artikelId
        }, function (artikel) {
          scope.updateMenge(artikel);
          g.artikel = artikel;
          scope.calculateTotal(g);
        });
      });

    scope.artikelGruppe.forEach((_, i) => {
      scope.$watch('artikelGruppe[' + i + '].open', scope.onOpen);
    });
  }
}



// WEBPACK FOOTER //
// ./app/components/VossIso.js